import MessageActionTypes from "Containers/Messages/types"

// Success message
export const removeMessageFromListByIdAction = payload => ({
  type: MessageActionTypes.REMOVE_MESSAGE_FROM_LIST,
  payload: payload,
})

// Success message
export const removeSuccessMessage = () => ({
  type: MessageActionTypes.REMOVE_SUCCESS_MESSAGE,
})

export const setSuccessMessage = message => ({
  type: MessageActionTypes.SET_SUCCESS_MESSAGE,
  payload: message,
})

// Error message
export const removeErrorMessage = () => ({
  type: MessageActionTypes.REMOVE_ERROR_MESSAGE,
})

export const setErrorMessage = message => ({
  type: MessageActionTypes.SET_ERROR_MESSAGE,
  payload: message,
})

// Warning message
export const removeWarningMessage = () => ({
  type: MessageActionTypes.REMOVE_WARNING_MESSAGE,
})

export const setWarningMessage = message => ({
  type: MessageActionTypes.SET_WARNING_MESSAGE,
  payload: message,
})

// Info message
export const removeInfoMessage = () => ({
  type: MessageActionTypes.REMOVE_INFO_MESSAGE,
})

export const setInfoMessage = message => ({
  type: MessageActionTypes.SET_INFO_MESSAGE,
  payload: message,
})

// SUccess code
export const setSuccessCode = code => ({
  type: MessageActionTypes.SET_SUCCESS_CODE,
  payload: code,
})
